<script>
import { useFundraiserStore } from '@/stores/fundraiser.js'
import FundraiserOldListGroupItem from '@/components/imports/import-fundraiser-old/fundraiser-old-list-group-item.vue'

export default {
  name: 'ImportFundraisersForOrganization',
  components: { FundraiserOldListGroupItem },
  props: {
    organization: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      LoadingFetchingOldFundraisers: false,
      LoadingFetchingFundraisers: false,
      OldFundraisers: null,
    }
  },
  computed: {
    fundraisers() {
      return useFundraiserStore().items
    }
  },
  mounted() {
    this.fetchOldFundraisersForOrganization()
    this.fetchFundraisersForOrganization()
  },
  methods: {
    async fetchOldFundraisersForOrganization() {
      try {
        this.ValidationErrorMessage = null
        this.LoadingFetchingOldFundraisers = true
        const { data } = await axios.get(`/api/v1/import/old-organization/${this.organization.old_id}/fundraisers`)
        this.OldFundraisers = data
        this.LoadingFetchingOldFundraisers = false
      } catch (e) {
        console.error(e)
        this.LoadingFetchingOldFundraisers = false
        if (e.response) this.ValidationErrorMessage = e.response.data
        throw e
      }
    },
    async fetchFundraisersForOrganization() {
      try {
        this.ValidationErrorMessage = null
        this.LoadingFetchingFundraisers = true
        await useFundraiserStore().fetchItems({
          organization_id: this.organization.id
        })
        this.LoadingFetchingFundraisers = false
      } catch (e) {
        console.error(e)
        this.LoadingFetchingFundraisers = false
        if (e.response) this.ValidationErrorMessage = e.response.data
        throw e
      }
    }
  }
}
</script>

<template>
  <div>
    <h1>Import Fundraisers for Organization</h1>
    <div class="divide-y">
      <fundraiser-old-list-group-item v-for="oldFundraiser in OldFundraisers" :key="'old-fundraiser-old-' + oldFundraiser.id" :organization="organization" :old-fundraiser="oldFundraiser" :fundraiser="fundraisers.find(item => item.old_id = oldFundraiser.id)" />
    </div>
  </div>
</template>

<style scoped>

</style>
